import { ProfileSectionProps } from "./types";
import { FormSection } from "@/features/common/components/FormSection";
import { DataField } from "@/features/common/components/DataField";
import { WorkContractStatusFields } from "./WorkContract/WorkContractStatusFields";
import { WorkContractDocumentField } from "./WorkContract/WorkContractDocumentField";

// Label mapping function
const getStatusLabel = (value: string) => {
  const labels: { [key: string]: string } = {
    not_started: "Nicht begonnen",
    in_progress: "In Bearbeitung",
    completed: "Abgeschlossen",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    not_required: "Nicht erforderlich",
    not_applicable: "Nicht zutreffend"
  };
  return labels[value] || value;
};

export function WorkContractSection({
  profile,
  setProfile,
  readOnly,
  loading
}: ProfileSectionProps) {
  const contractStatus = profile?.work_contract_status || "not_applied";

  return (
    <FormSection title="Arbeitsvertrag">
      <div className="space-y-6">
        <WorkContractStatusFields
          profile={profile}
          setProfile={setProfile}
          readOnly={readOnly}
          loading={loading}
        />

        {(contractStatus === "received" || contractStatus === "signed") && (
          <WorkContractDocumentField
            profile={profile}
            setProfile={setProfile}
            readOnly={readOnly}
            loading={loading}
          />
        )}
      </div>
    </FormSection>
  );
}

// View component
export function WorkContractView({ profile }: { profile: any }) {
  return (
    <div className="space-y-1">
      <DataField
        label="Vertragsstatus"
        value={
          profile.contract_status
            ? getStatusLabel(profile.contract_status)
            : null
        }
      />
    </div>
  );
}
